<script setup lang="ts">
import {Head, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import TextField from "@/Pages/auth/components/TextField.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";
import SingleActionCard from "@/Pages/auth/components/SingleActionCard.vue";
import {useUserAvatar} from "@/composables/avatar";
import {User} from "@/types";

interface Props {
    user: User
}

defineOptions({layout: Layout})
const props = defineProps<Props>()
const form = useForm({
    password: '',
})

const submit = () => {
    form.post(route('password.confirm'), {
        onFinish: () => {
            form.reset()
        },
    })
}
</script>

<template>
    <Head title="Confirm access" />
    <form-card
        :loading="form.processing"
        :error-messages="form.errors.password"
        @submit="submit"
    >
        <template #title>
            Confirm access
        </template>
        <template #prepend>
            <single-action-card class="mb-5">
                <v-list-item
                    :slim="true"
                    density="compact"
                    class="pa-0"
                >
                    <template #prepend>
                        <v-avatar
                            size="36"
                            rounded="xl"
                            class="border-sm"
                        >
                            <v-img
                                :src="useUserAvatar(props.user.name)"
                                contain
                            />
                        </v-avatar>
                    </template>
                    <v-list-item-title class="text-body-1">
                        Signed in as <b>{{ props.user.name }}</b>
                    </v-list-item-title>
                </v-list-item>
            </single-action-card>
        </template>
        <text-field
            v-model="form.password"
            label="Password"
            type="password"
            autocomplete="current-password"
            :autofocus="true"
            :required="true"
            :hide-required-asterisk="true"
        />
        <template #submit>
            Confirm
        </template>
        <template #append>
            <legend class="mt-5 text-body-2 text-grey-darken-2 text-center">
                <b>Tip:</b> You are entering restricted area. Please confirm your password to continue.
            </legend>
        </template>
    </form-card>
</template>

<style scoped>

</style>
